import { useLingui } from '@lingui/react'
import { TextField } from '@mui/material'
import { useController } from 'react-hook-form'

/*eslint-disable*/
function TextInput({ control, name, autoFocus = null, label, type, required, defaultValue = true }) {
    const { _ } = useLingui()
    const {
      field,
      fieldState: { invalid, isTouched, isDirty },
      formState: { touchedFields, dirtyFields },
    } = useController({
      name,
      defaultValue: type === 'number' ? null : '',
      control,
      rules: { required: required ?? true },
    })
  
    return (
      <TextField
        onChange={field.onChange} // send value to hook form
        onBlur={field.onBlur} // notify when input is touched/blur
        value={field.value} // input value
        name={field.name} // send down the input name
        inputRef={field.ref} // send input ref, so we can focus on input when error appear
        margin='normal'
        required={required ?? true}
        label={label}
        key={label}
        inputProps={{
          min: type && type === 'number' && 0,
          max: type && type === 'number' && 20,
          inputMode: type && type === 'number' ? 'numeric' : 'text', 
        }}
        fullWidth
        type={type || 'text'}
        autoFocus={!!autoFocus}
      />
    )
  }

  export default TextInput;